import { render, staticRenderFns } from "./AppStaticLayout.vue?vue&type=template&id=5088caa8&scoped=true&lang=pug&"
import script from "./AppStaticLayout.vue?vue&type=script&lang=ts&"
export * from "./AppStaticLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AppStaticLayout.vue?vue&type=style&index=0&id=5088caa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5088caa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
